// extracted by mini-css-extract-plugin
export default {"input":"Select_input__uq+Lx","title":"Select_title__2qqWh"};